import React, { useState } from 'react';
import './Contact.css';

const HERO_IMG = '/inside3.png';

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required';
    if (!form.phone.trim()) e.phone = 'Phone is required';
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Valid email is required';
    if (!form.message.trim()) e.message = 'Message is required';
    return e;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) { setErrors(errs); return; }
    setSubmitted(true);
  };

  const handleChange = (field, val) => {
    setForm(prev => ({ ...prev, [field]: val }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: null }));
  };

  const serviceAreas = ['Chesterfield Township', 'Clinton Township', 'Macomb Township', 'New Baltimore'];

  return (
    <main>
      <div className="page-hero">
        <img src={HERO_IMG} alt="Restaurant exterior" />
        <div className="page-hero-content">
          <p style={{ fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: '1rem', letterSpacing: '0.2em', color: 'var(--gold-pale)', marginBottom: '0.5rem' }}>We'd Love to Hear From You</p>
          <h1>Connect<br /><em style={{ fontSize: '0.8em' }}>With Us</em></h1>
          <a href="tel:5869484900" className="phone-link">586-948-4900</a>
        </div>
      </div>

      <div className="gold-bar" />

      {/* Intro */}
      <section className="section contact-intro">
        <div className="container">
          <div className="contact-intro__text">
            <h2 className="section-title">Get in Touch</h2>
            <div className="divider-ornament"><span>✦</span></div>
            <p>
              When you're on the lookout for an Italian restaurant that offers authentic Italian
              dishes, Giuseppe's Restaurant is the way to go. We also offer catering services and
              accept banquet hall reservations and special event bookings.
            </p>
          </div>
        </div>
      </section>

      {/* Main Contact Layout */}
      <section className="contact-main">
        <div className="contact-main__map">
          <iframe
            title="Giuseppe's Restaurant Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2938.123456789!2d-82.8435!3d42.5781!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8824e5b00000001%3A0x1234567890!2s49120+Gratiot+Ave%2C+Chesterfield%2C+MI+48051!5e0!3m2!1sen!2sus!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="contact-main__info">
          <div className="contact-info-block">
            <h3>Contact Information</h3>
            <div className="divider-ornament" style={{ margin: '1rem 0' }}><span>✦</span></div>

            <div className="contact-detail">
              <span className="contact-detail__icon">📍</span>
              <div>
                <strong>Giuseppe's Restaurant</strong>
                <p>49120 Gratiot Ave</p>
                <p>Chesterfield, Michigan 48051</p>
              </div>
            </div>

            <div className="contact-detail">
              <span className="contact-detail__icon">📞</span>
              <div>
                <strong>Phone</strong>
                <p><a href="tel:5869484900">586-948-4900</a></p>
              </div>
            </div>

            <div className="contact-detail">
              <span className="contact-detail__icon">📘</span>
              <div>
                <strong>Follow Us</strong>
                <p>
                  <a href="https://www.facebook.com/GiuseppesRestaurant" target="_blank" rel="noreferrer">
                    Facebook
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="contact-areas">
            <h4>Service Areas</h4>
            <ul>
              {serviceAreas.map(a => <li key={a}><span className="dot" />  {a}</li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Form */}
      <section className="section contact-form-section">
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center' }}>Inquiry Form</h2>
          <div className="divider-ornament" style={{ margin: '1rem auto 3rem' }}><span>✦</span></div>

          {submitted ? (
            <div className="form-success">
              <div className="form-success__icon">✓</div>
              <h3>Thank You!</h3>
              <p>Your message has been received. We'll be in touch shortly.</p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              <div className="form-row">
                <div className={`form-group ${errors.name ? 'error' : ''}`}>
                  <label>Name *</label>
                  <input
                    type="text"
                    placeholder="Your full name"
                    value={form.name}
                    onChange={e => handleChange('name', e.target.value)}
                  />
                  {errors.name && <span className="form-error">{errors.name}</span>}
                </div>
                <div className={`form-group ${errors.phone ? 'error' : ''}`}>
                  <label>Phone *</label>
                  <input
                    type="tel"
                    placeholder="Your phone number"
                    value={form.phone}
                    onChange={e => handleChange('phone', e.target.value)}
                  />
                  {errors.phone && <span className="form-error">{errors.phone}</span>}
                </div>
              </div>
              <div className={`form-group ${errors.email ? 'error' : ''}`}>
                <label>Email *</label>
                <input
                  type="email"
                  placeholder="your@email.com"
                  value={form.email}
                  onChange={e => handleChange('email', e.target.value)}
                />
                {errors.email && <span className="form-error">{errors.email}</span>}
              </div>
              <div className={`form-group ${errors.message ? 'error' : ''}`}>
                <label>Message *</label>
                <textarea
                  placeholder="Tell us about your inquiry, reservation, or catering needs..."
                  rows={5}
                  value={form.message}
                  onChange={e => handleChange('message', e.target.value)}
                />
                {errors.message && <span className="form-error">{errors.message}</span>}
              </div>
              <button type="submit" className="btn-primary form-submit">Send Message</button>
            </form>
          )}
        </div>
      </section>
    </main>
  );
}
